export const triggerPlausibleEvent = (event) => {
  if (event?.name && window.plausible) {
    const { name, props } = event;
    window.plausible(name, props && { props });
  }
};
